import ReactDOM from "react-dom/client";
import React, { cache, useMemo , useState, useRef, useEffect  } from 'react';
import { BrowserRouter, Routes, Route, Link, Outlet } from "react-router-dom";
// import Layout from "./Layout";
import Home from "./Home";
import Specifications from "./Specifications";
import Product from "./Product";
import ProductInfo from './ProductInfo';
import Contact from "./Contact";
import NoPage from "./NoPage";
import RequestRepair from "./RequestRepair";
import ShopList from "./ShopList";
import Login from "./Login";
import Basket from "./Basket";
import Checkout from "./Checkout";
import Thankyou from  './Thankyou';
import './App.css';
import Footer from "./Footer";
import Orders from "./Orders";
import OrderDetails from "./OrderDetails";
import Register from "./Register";
import { FaCircleMinus, FaCirclePlus, FaBasketShopping, FaXmark, FaBars, FaCircleUser, FaHouse, FaBoxOpen, FaGears, FaEnvelope, FaRightFromBracket, FaBoxesPacking, FaScrewdriverWrench  } from "react-icons/fa6";
var globalScroll = 0;


export default function App() {

  const [showBasket, setShowBasket] = useState(false);
  const [basket, setBasket] = useState(window.localStorage.getItem('MuckS_Basket'))
  const [showLoginHeader, setShowLoginHeader] = useState(false);
  const [loggedIn, setLoggedIn] = useState(window.localStorage.getItem('MuckS_LoginState'))
  const [showLoginHeaderMobile, setShowLoginHeaderMobile] = useState(false);
  const basketElement = useRef();

  var scrollRef = useRef(0);
  var elementHeightRef = useRef(0);

  var ibasketTotal = 0;

  function hidePopUps() 
  {
    console.log("Click");
    //objBasket = objBasket.splice(productid, 1);
    setShowLoginHeader(false);
    setShowBasket(false);
    setShowLoginHeaderMobile(false);
  }
  function goHome() 
  {
    setShowLoginHeader(false);
    setShowBasket(false);
    setShowLoginHeaderMobile(false);
    window.location = 'https://mucksucker.com/';
  }

  function toggleBasket()
  {
    setShowLoginHeader(false);
    setShowLoginHeaderMobile(false);
    setShowBasket(!showBasket);
  }

  function toggleLogin()  {
    setShowBasket(false);
    setShowLoginHeaderMobile(false);
    setShowLoginHeader(!showLoginHeader);
  }

  function toggleMobileMenu()  {
    setShowBasket(false);
    setShowLoginHeader(false);
    setShowLoginHeaderMobile(!showLoginHeaderMobile);

  }

  const handleBasketScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const position = Math.ceil(
        (scrollTop / (scrollHeight - clientHeight)) * 100
    );
    console.log(clientHeight);
    console.log(scrollTop);
    elementHeightRef = clientHeight;
    scrollRef = scrollTop;
    globalScroll = scrollTop;
  }

  const LoginHeader = (props)  => 
  {

    var objLoggedIn = [];

    if(loggedIn)
      {
        try 
        {
          objLoggedIn = JSON.parse(loggedIn);
        } 
        catch(error) 
        {
            
        }
      }
  

    const handleLogout = (e) =>
        {
            e.preventDefault();
            localStorage.removeItem('MuckS_LoginState');
            setLoggedIn(null);
        }

    return(
    <div className="loginHeader">
          <FaCircleUser  onClick={() => toggleLogin()}/>
          { showLoginHeader ? 
          <div className="loginHeaderContainer">
              <h3 className="loginHeader">Login</h3>
              <div className="loginHeaderItemContainer">
                  
              { loggedIn ? 
              <div className="accountSidebarContainer">
                <div className="loginMenuContainer">
                  <FaBoxesPacking /><Link className="loginHeader" to="/orders">Orders</Link>
                </div>
                <div className="loginMenuContainer">
                  <FaScrewdriverWrench /> <Link className="loginHeader" to="/requestrepair">Request Repair</Link>
                </div>
                <div className="loginMenuContainer">
                  <FaRightFromBracket /><a className="loginHeader" onClick={handleLogout}>Logout</a>
                </div>
              </div>
                  : <a className="loginHeader" href='./login'>Login</a>
                  }
              </div>
          </div>

          : 

          null }

      </div>
    )
  }

  const BasketHeader = (props) => 
  {
    const handleRemoveItem = (e, productid) =>
    {
      e.preventDefault();
        console.log("In Remove Loop");
        //objBasket = objBasket.splice(productid, 1);
        var deletedArray = objBasket.filter(item => item.id !== productid);
        localStorage.setItem('MuckS_Basket', JSON.stringify(deletedArray));
        setBasket(JSON.stringify(deletedArray));
    }

    const handleAddOneItem = (e, productid) =>
    {
      e.preventDefault();
      console.log(productid);
      console.log(JSON.parse(basket));
      var tempBasket = JSON.parse(basket);
      var result = tempBasket.find(obj => {
        return obj.iProductID === productid
      })

      tempBasket.push(result);
      localStorage.setItem('MuckS_Basket', JSON.stringify(tempBasket));
      setBasket(JSON.stringify(tempBasket));
    }

    const handleRemoveOneItem = (e, productid, iQuantity) =>
    {
      e.preventDefault();
      if(iQuantity == 1)
      {
        alert("Remove With Cross");
      }
      else
      {
        console.log(productid);
        console.log(JSON.parse(basket));
        var tempBasket = JSON.parse(basket);
  
        var index = tempBasket.findIndex(function(obj) {
          return obj.iProductID === productid
        });
  
        tempBasket.splice(index, 1);
        localStorage.setItem('MuckS_Basket', JSON.stringify(tempBasket));
        setBasket(JSON.stringify(tempBasket));
      }
    }

    
    const handleBasketItemClick = (e, productid) =>
    {
      e.preventDefault();

      if(e.target.nodeName == "path" || e.target.nodeName == "svg")
      {

      }
      else
      {
        toggleBasket();
        window.location = `https://mucksucker.com/productinfo?product=${productid}`;
      }


    }


    var objBasket = [];
    var objBasketRender = [];
    if(basket)
    {
      try 
      {
          objBasket = JSON.parse(basket);
          console.log(objBasket);
          
          let uniqueData = [];
          objBasket.forEach(data => {
          let index = uniqueData.findIndex(item=> item.iProductID === data.iProductID);
              if (index === -1) { 
                  data.quantity=1;
                  uniqueData = [...uniqueData, data];
              }
              else {
                  uniqueData[index].quantity++;
              }
          })
          console.log(uniqueData);
          uniqueData.sort(function(a, b) { 
            return a.iProductID - b.iProductID  ||  a.iProductID.localeCompare(b.iProductID);
          });
          objBasketRender = uniqueData;

      } 
      catch(error) 
      {
        objBasket =[];
      }
    }

    objBasket.forEach(function (item, index) 
    {
      ibasketTotal = ibasketTotal + item.price
    });

    var basketTotal = (ibasketTotal/100).toFixed(2);

    const basketItems = objBasketRender.map((product) =>
        <li key={product.id} dataid={product.Name}>
          <Link className="basketItem" onClick={(e) => handleBasketItemClick(e, product.iProductID)}>
            <div className="basketItemTitleContainer">
              <img alt="basketItem" className="basketImg" src={product.img} />
              <div className="basketPriceContainer">
                <div className="removeTitleBasketContainer">
                  <strong className="basketProductTitle">{product.Name}</strong>
                  <div className="removeBasketContainer">
                    <FaXmark color="white" onClick={(e) => handleRemoveItem(e, product.id)} />
                  </div>
                </div>

                <div className="basketPriceQuantityContainer">
                  <strong className="basketPrice"> £{(product.price/100).toFixed(2)}</strong>
                  <div className="basketQuantityControlContainer">
                    <FaCirclePlus onClick={(e) => handleAddOneItem(e, product.iProductID)} />
                      <strong className="textQuantityBaket">{product.quantity}</strong>
                    <FaCircleMinus onClick={(e) => handleRemoveOneItem(e, product.iProductID, product.quantity)} />
                  </div>
                </div>

              </div>
            </div>

          </Link>

        </li> 
    );

    const setScrollPosition = (element) => {
      if(element)
        {
          element.scrollTo({
            top: globalScroll,
            behavior: "instant"
          });
        }

    };

    const basketCount= <p className="basketCount">{objBasket.length}</p>;
    useEffect(() => {
      setScrollPosition(basketElement.current);
    });
  
    
    return(
      <div className="basketHeader">
          <FaBasketShopping onClick={() => toggleBasket()}/>
          <div className="basketCounter">
              {basketCount}
          </div>
          { showBasket ?  <div className="basketContainerMaster"><div className="basketContainer">
              
              <div className="basketTitleContainer">
                <h3 className="basketHeader">Basket</h3>
                <div className="basketHeaderCross">
                  <FaXmark color="red" onClick={() => toggleBasket()} />
                </div>
              </div>

              <div className="basketItemContainer">
              { 
                  basket ? <div>
                      <ul style={{minHeight: elementHeightRef}} onScroll={handleBasketScroll} 
                          id="scrollDemo"
                          ref={basketElement}
                          className="basketUl">
                          {basketItems}
                      </ul>
                  </div>
                  :
                  <p>No Items Added</p>
              }

              </div>
            </div>
            <div className="basketFooter">
              <div className="basketFooterChild">
                <div className="footerItemContainer">
                  <p>Items Selected</p>
                  <p>{basketCount}</p>
                </div>
                <div className="footerItemContainer">
                  <h2>Total</h2>
                  <h2 className="baketPrice">£{basketTotal}</h2>
                </div>

                <div className="footerItemContainerCheckout">
                  <Link className="basketFooterItem" to="/checkout">Order Now</Link>
                </div>
                  
                </div>
              </div>
          </div>: null }

      </div>
    )
  }

  const Layout = (props) => 
  {
    const [token, setToken] = useState();
  
    var strToken = "My TOKEN";
    if(!token) 
    {
      setToken({id: 1});
    }
    else
    {
      strToken = "Hello Token"
    }
  
    return (
      <>
        <div className="main">
          
        <nav className="nav">
          <div className="imgHeaderContainer">
            <img onClick={() => goHome()} alt="mainBanner" rel="preload" fetchpriority="high" loading="eager" className="imgBanner" src={require('./mucksuckerlogonew.webp')} />
          </div>
          <div className="navContainer">

            
            <ul className="navMenu">
              <FaBars onClick={() => toggleMobileMenu()} className="burgerMenuIcon" />

              { showLoginHeaderMobile ? 

                <div className="mobileMenuContainer">
                  <li className="headerLinkMobile imgBannerMobileMenuContainer">
                  <img className="imgBannerMobileMenu" src={require('./iconms.png')} />
                  </li>
                <li className="headerLinkMobile">
                    <FaHouse />
                    <Link onClick={hidePopUps} to="/">Home</Link>
                  </li>
                  <li className="headerLinkMobile">
                    <FaBoxOpen />
                    <Link onClick={hidePopUps} to="/product">Product</Link>
                  </li>
                  <li className="headerLinkMobile">
                    <FaGears />
                    <Link onClick={hidePopUps} to="/Specifications">Specifications</Link>
                  </li>
                  <li className="headerLinkMobile">
                    <FaEnvelope />
                    <Link onClick={hidePopUps} to="/contact">Contact</Link>
                  </li>
                </div>
                :
                null 
              }


              <li className="headerLink">
                  <Link onClick={hidePopUps} to="/">Home</Link>
                </li>
                <li className="headerLink">
                  <Link onClick={hidePopUps} to="/product">Product</Link>
                </li>
                <li className="headerLink">
                  <Link onClick={hidePopUps} to="/Specifications">Specifications</Link>
                </li>
                {/* <li className="headerLink">
                  <Link onClick={hidePopUps} to="/shoplist">Shop</Link>
                </li> */}
                <li className="headerLink">
                  <Link onClick={hidePopUps} to="/contact">Contact</Link>
                </li>
              </ul>
              <div className="LoginHeaderMaster">
                <LoginHeader state={token}/>
                {/* <BasketHeader state={token}/> */}
            </div>
          </div>  
  
        </nav>
  
          <Outlet />
  
          </div>
  
        <Footer />
  
      </>
    )
  };
  
  function hideCheckout() 
  {
    //objBasket = objBasket.splice(productid, 1);
    setShowBasket(false);

  }
    
  function handleState(newValue) 
  {
    //objBasket = objBasket.splice(productid, 1);
    localStorage.setItem('MuckS_Basket', JSON.stringify(newValue));
    setBasket(JSON.stringify(newValue));

  }
  function handleLogin(newValue) 
  {
    //objBasket = objBasket.splice(productid, 1);
    localStorage.setItem('MuckS_LoginState', newValue);
    setLoggedIn(newValue);

  }


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="Specifications" element={<Specifications />} />
          <Route path="product" element={<Product />} />
          <Route path="ProductInfo" element={<ProductInfo change = {handleState} />} />
          <Route path="contact" element={<Contact />} />
          <Route path="login" element={<Login change = {handleLogin}/>} />
          <Route path="register" element={<Register />} />
          <Route path="checkout" element={<Checkout change = {hideCheckout} />} />
          <Route path="Basket" element={<Basket change = {handleState}/>} />
          <Route path="shoplist" element={<ShopList />} />
          <Route path="requestrepair" element={<RequestRepair />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orderdetails" element={<OrderDetails />} />
          <Route path="thankyouend" element={<Thankyou change = {handleState}/>} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);